import { validateNegativeNumber, validatePositiveInteger, validateWageRateExpirationDate } from "../../../utils/formHelper";

const convertToFields = fields => {
  return fields?.map(fieldName => ({
    label: fieldName,
    key: fieldName,
    fieldType: { type: "input" },
    description: fieldName
  }));
};

export const EmployeesExcelData = [
  "Project Labor Classification Title",
  "Start Date",
  "End Date",
  "Employment Term Type",
  "PerDiem",
  "Wage Rate",
  "Fringe",
  "First Name",
  "Middle Name",
  "Last Name",
  "Cell Phone",
  "Office Phone",
  "Whatsapp Number",
  "Email",
  "Address",
  "Address2",
  "City",
  "State",
  "Zip",
  "Date Of Birth",
  "Last Four Digit SSN",
  "Apprentice Job",
  "Total Hourly Comp",
  "Internal Id",
  "Project Job Title"
];

export const mapProjectEmployee = row => {
  const val = key => {
    const raw = row?.[key];
    return raw == null ? "" : String(raw).trim();
  };

  return {
    projectJobTitle: val("Project Job Title"),
    StartDate: val("Start Date"),
    endDate: val("End Date"),
    employmentTermType: val("Employment Term Type"),
    perDiem: val("PerDiem"),
    wageRate: val("Wage Rate"),
    fringe: val("Fringe"),
    firstName: val("First Name"),
    middleName: val("Middle Name"),
    lastName: val("Last Name"),
    cellPhone: val("Cell Phone"),
    officePhone: val("Office Phone"),
    whatsAppNumber: val("Whatsapp Number"),
    email: val("Email"),
    address: val("Address"),
    address2: val("Address2"),
    city: val("City"),
    state: val("State"),
    zip: val("Zip"),
    dateOfBirth: val("Date Of Birth"),
    last4ofSSN: val("Last Four Digit SSN"),
    apprenticeJob: val("Apprentice Job"),
    totalHourlyComp: val("Total Hourly Comp"),
    internalEmployeeId: val("Internal Id")
  };
};

const timeSheetMultiRowData = [
  "First Name",
  "Last Name",
  "Email",
  "Worked Date",
  "Total Standard Hours",
  "Total Over Time Hours",
  "Standard Pay Rate",
  "Over Time Pay Rate",
  "Per Diem",
  "Position",
  "Employee Internal Id",
  "Week Ending Date"
];

const timeSheetMultiRowDataV2 = [
  "First Name",
  "Last Name",
  "Worked Date",
  "Total Standard Hours",
  "Total Over Time Hours",
  "Total Double Time Hours",
  "Labor Classification",
  "Work Area",
  "Employee Internal Id",
  "Week Ending Date"
];

export const getTimeSheetFields = (isVersionTwo, hasWorkAreas) => {
  let timeSheetFields = isVersionTwo ? timeSheetMultiRowDataV2 : timeSheetMultiRowData;
  if (!hasWorkAreas) {
    timeSheetFields = timeSheetFields.filter(field => field !== "Work Area");
  }
  return convertToFields([...timeSheetFields, "isAmendment"]);
};

export const timeSheetSingleRowData = [
  "First Name",
  "Last Name",
  "Email",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
  "Total Standard Hours",
  "Total Over Time Hours",
  "Total Double Time Hours",
  "Standard Pay Rate",
  "Over Time Pay Rate",
  "Double Time Pay Rate",
  "Per Diem",
  "Payroll Number",
  "Position",
  "Employee Internal Id",
  "Week Ending Date"
];

export const timeSheetSingleRowFields = convertToFields(timeSheetSingleRowData);

const payrollFieldsNameV1 = [
  "Week Ending Date",
  "Last Name",
  "First Name",
  "Position",
  "Regular Pay Rate",
  "Regular Hours",
  "Regular Total",
  "Over Time Pay Rate",
  "Over Time Hours",
  "Over Time Total",
  "Per Diem",
  "Total Hours",
  "Gross Amount Earned this Project",
  "Total Pay",
  "FICA",
  "FED WH TAX",
  "STATE WH TAX",
  "Other Deduction 1",
  "Other Deduction 2",
  "Total Deductions",
  "Net Wage Paid For Week",
  "Other Deduction 1 Explanation",
  "Other Deduction 2 Explanation",
  "Exception",
  "Explanation",
  "Employee Internal Id",
  "Paycheck Number"
];

const payrollFieldsNameV2 = [
  "Week Ending Date",
  "Last Name",
  "First Name",
  "Employee Internal Id",
  "Labor Classification",
  "Work Area",
  "Straight Hours",
  "Straight Pay Rate",
  "Over Time Hours",
  "Over Time Pay Rate",
  "Double Time Hours",
  "Double Time Pay Rate",
  "Total Fringe Benefit Credit",
  "Payment in Lieu of Fringe Benefits",
  "Gross Amount Earned this Project",
  "Gross Pay All Projects",
  "FED WH TAX",
  "STATE TAX",
  "FICA",
  "Other Deduction 1",
  "Total Deductions",
  "Net Wage Paid For Week",
  "Other Deduction 1 Explanation",
  "Health Insurance Fringe Credit Hourly Rate",
  "Life Insurance Fringe Credit Hourly Rate",
  "Retirement Fringe Credit Hourly Rate",
  "Apprentice Training Fringe Credit Hourly Rate",
  "Vacation or Sick Time Fringe Credit Hourly Rate",
  "Holiday Time Fringe Credit Hourly Rate",
  "Supplementary Unemployment Benefits Fringe Credit Hourly Rate",
  "Exception",
  "Explanation",
  "Paycheck Number",
  "Paycheck Date"
];

export const getPayrollFields = (isVersionTwo, hasWorkAreas) => {
  let fields = isVersionTwo ? payrollFieldsNameV2 : payrollFieldsNameV1;
  if (!hasWorkAreas) {
    fields = fields.filter(field => field !== "Work Area");
  }

  const convertedFields = convertToFields(
    [...fields, "isAmendment"]
  );

  const mappedFields = convertedFields.map(field => {
    if (field.label === "Labor Classification") {
      return {
        ...field,
        alternateMatches: ["Position", "Labor Classification"]
      };
    }
    if (field.label === "Straight Hours") {
      return {
        ...field,
        alternateMatches: ["Regular Hours", "Straight Hours"]
      };
    }
     if (field.label === "Straight Pay Rate") {
      return {
        ...field,
        alternateMatches: ["Regular Pay Rate", "Straight Pay Rate"]
      };
    }
     if (field.label === "STATE TAX") {
      return {
        ...field,
        alternateMatches: ["STATE TAX", "STATE WH TAX"] 
      };
    }
     if (field.label === "Total Fringe Benefit Credit") {
      return {
        ...field, 
        alternateMatches: ["Total Fringe Benefit Credit"] 

      };
    }
     if (field.label === "Payment in Lieu of Fringe Benefits") {
      return {
        ...field, 
        alternateMatches: ["Payment in Lieu of Fringe Benefits", "Payment in Lieu of Fringe Benefit"] 
      };
    }
     if (field.label === "Gross Amount Earned this Project") {
      return {
        ...field,
        alternateMatches: ["Gross Amount Earned this Project", "Gross Amount Earned"]
      };
    }
    return field;
  });

  return mappedFields;
};

export const ProjectInfoConfig = {
  totalWorkforceHours: {
    label: "What % of Total Workforce Hours will be worked by Apprentices?",
    perKey: "PercentageApprenticeWork",
    defaultValue: null,
    rules: {
      required: "Required!",
      pattern: {
        value: /^[0-9]+$/,
        message: "Please enter numbers only"
      }
    }
  },
  moreThanFourEmployees: {
    label: "As a Labor Provider will you be employing more than 4 employees on this Project?",
    perKey: "MoreThanFourEmployees",
    defaultValue: null,
    rules: {
      validate: value => (value !== null ? true : "Required!")
    }
  },
  typicalshiftdays: {
    label: "What will be the typical shift and days worked by the workforce employed on this project?",
    defaultValue: [],
    perKey: "TypicalShiftDay",
    rules: { required: "Required!" }
  },
  shiftStartTime: {
    label: "Start Time",
    defaultValue: null,
    perKey: "ShiftStartTime",
    rules: {
      required: "Start Time is required!",
      validate: value => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter a valid time";
        return true;
      }
    }
  },
  shiftEndTime: {
    label: "End Time",
    defaultValue: null,
    perKey: "ShiftEndTime",
    rules: {
      required: "End Time is required!",
      validate: value => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter a valid time";
        return true;
      }
    }
  },
  employeeCount: {
    label: "How many employees will you be hiring for this project?",
    type: "number",
    perKey: "EmployeeCount",
    defaultValue: null
  },
  certifiedPayrollEmailAddress: {
    label: "Owner Certified Payroll Email Address",
    perKey: "OwnerCertifiedPayrollSignatoryEmail",
    defaultValue: null
  },
  daysofWeekBegin: {
    label: "On what day of the week does your pay period begin?",
    perKey: "PayPeriodBegin",
    defaultValue: null,
    rules: { required: "Required!" }
  },
  daysofWeekEnd: {
    label: "On what day of the week does your pay period end?",
    perKey: "PayPeriodEnd",
    defaultValue: null,
    rules: { required: "Required!" }
  },
  workforceStartDate: {
    label: "Workforce Start Date",
    defaultValue: null,
    perKey: "WorkforceStartDate",
    rules: {
      required: "Workforce Start Date is required!",
      validate: (value, formValues) => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter valid date";
        if (formValues.workForceEndDate && formValues.workForceEndDate < value) {
          return "Workforce Start Date should be less than Workforce End Date";
        }
        return true;
      }
    }
  },
  workForceEndDate: {
    label: "Workforce End Date",
    defaultValue: null,
    perKey: "WorkforceEndDate",
    rules: {
      validate: (value, formValues) => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter valid date";
        if (formValues.workforceStartDate && formValues.workforceStartDate > value) {
          return "Workforce End Date should be greater than Workforce Start Date";
        }
        return true;
      }
    }
  },
  useProscoreMobileApp: {
    label: "Will you be using the ProScore Mobile App for Timekeeping Management?",
    withInfoIcon: false,
    perKey: "UseProscoreMobileApp",
    defaultValue: false
  },
  timeKeepingSystem: {
    label: "What Time Keeping System will be capturing worker time on a daily basis?",
    perKey: "TimeKeepingSystem",
    defaultValue: null
  },
  provideTimeKeepingOn: {
    label: "Will you be providing timekeeping data on a daily or weekly basis?",
    perKey: "ProvideTimeKeepingOn",
    defaultValue: null
  },
  payrollOn: {
    label: "Are you running payroll on a weekly, biweekly, or monthly basis?",
    perKey: "PayrollOn",
    defaultValue: null
  },
  uploadDailyTimeSheet: {
    label: "Daily time sheet",
    perKey: "UploadDailyTimeSheet",
    defaultValue: null
  },

  isAllowMoreThanOneSiteLocation: {
    label: "Does the Timekeeping System allow the worker to enter more than one site location (Apprentice)?",
    perKey: "IsAllowMoreThanOneSiteLocation",
    defaultValue: false
  },
  isAllowWorkerToAddMoreThanOneOccupation: {
    withInfoIcon: true,
    label:
      "Does the Timekeeping System(if not using the ProScore mobile app) allow the worker to enter more than one occupation during work period (shift)?",
    infoMessage:
      "To ensure compliance under IRA framework the employer has to ensure the employee is getting paid the proper Prevailing Wage given the job or duties performed throughout the entire shift. For example: If an Electrician or Installer doesn't have any materials to install during the shift and they dig trenches or take out the trash, they would be classified as a different Labor Classification title and a new rate potentially applies.",
    perKey: "IsAllowWorkerToAddMoreThanOneOccupation",
    defaultValue: false
  },
  isCertifiedPayrollAutoGenarate: {
    label: "Auto Generate Certified Payroll Reports",
    perKey: "AutoGenerateCertifiedPayrollReports",
    type: "checkbox",
    defaultValue: true
  },
  adaptiveElearning: {
    label: "Adaptive RTI",
    withInfoIcon: true,
    perKey: "IsAdaptive",
    infoMessage: "Scenario: Use a safety trailer during bad weather for continuous RTI. Benefit: Seamless training despite weather challenges.",
    defaultValue: false
  },
  flexibleElearning: {
    label: "Flexible RTI Options",
    withInfoIcon: true,
    perKey: "IsFlexible",
    defaultValue: false,
    infoMessage: "Scenario: Apprentices can choose bulk RTI during downtime. Advantage: Flexible scheduling, no rigid daily/weekly structures."
  },
  accelaratedElearning: {
    label: "Accelerated RTI",
    withInfoIcon: true,
    perKey: "IsAccelerated",
    defaultValue: false,
    infoMessage:
      "Scenario: Complete Year 1 curriculum in 3 weeks through intensive RTI. Outcome: Accelerated progress towards journeyworker certification."
  },
  courseContentDelivery: {
    label: "Course Content Delivery",
    perKey: "CourseContentDelivery",
    defaultValue: null
  },
  apprenticeHoursTracking: {
    label: "Apprentice Hours Tracking",
    perKey: "ApprenticeHoursTracking",
    defaultValue: null
  },
  adminAssignDailyApprenticeMentor: {
    label: "Admin will assign Daily Mentor:Apprentice",
    withInfoIcon: false,
    perKey: "adminAssignDailyApprenticeMentor",
    defaultValue: false
  },
  adminAssignDailyWPS: {
    label: "Admin will assign Daily WPS",
    withInfoIcon: false,
    perKey: "adminAssignDailyWPS",
    defaultValue: false
  },

  learningHoursPaid: {
    label: "Are RTI hours paid?",
    perKey: "LearningHoursPaid",
    defaultValue: null
  },
  relatedInstructionProvidedHours: {
    label: "Hours When Related Instruction Is Provided",
    perKey: "RelatedInstructionProvidedHours",
    defaultValue: null
  },
  preferredRTIDays: {
    label: "Preferred days and time for RTI/class time",
    perKey: "PreferredRTIDays",
    defaultValue: null
  },
  maxPaidHoursPerDay: {
    label: "Recommended Daily RTI (Minutes)",
    perKey: "MaxPaidHoursPerDay",
    defaultValue: null
  },
  preferredDaysEndTime: {
    label: "End Time",
    defaultValue: null,
    perKey: "EndTime"
  },
  preferredDayStartTime: {
    label: "Start Time",
    defaultValue: null,
    perKey: "StartTime"
  },
  rtiWeeklyExpectationHours: {
    label: "RTI Weekly Expectation Hours",
    perKey: "RTIWeeklyExpectationHours",
    defaultValue: null
  },
  rtiWeeklyExpectationMins: {
    label: "RTI Weekly Expectation Minutes",
    perKey: "RTIWeeklyExpectationMins",
    defaultValue: null
  },
  fringePayMode: {
    label: "Fringe Pay Mode",
    perKey: "fringePayMode",
    defaultValue: null,
    rules: { required: "Fringe Pay Mode is required!" }
  },
  contractorType: {
    label: "Contractor Type",
    perKey: "contractorType",
    defaultValue: null,
    rules: { required: "Contractor Type is required!" }
  },
  cprVersionLabel: {
    label: "CPR Version",
    perKey: "cprVersionLabel",
    defaultValue: null,
    rules: { required: "CPR Version is required!" }
  },

};

const validateInput = value => {
  if (!value) {
    return "Project Name is required!";
  }

  if (typeof value === "string") {
    return;
  }
  return "Please select a valid option";
};

export const ProjectProfileConfig = {
  projectName: {
    perKey: "ProjectName",
    label: "Project Name",
    rules: { required: "Project Name is Required!", validate: validateInput }
  },
  address1: {
    label: "Address 1",
    perKey: "Address1",
    rules: { required: "Address 1 is Required!" }
  },
  address2: {
    label: "Address 2",
    perKey: "Address2"
  },
  city: {
    label: "City",
    perKey: "CIty",
    rules: {
      required: "City is Required!",
      validate: value =>
        (typeof value === "string" && value.trim() !== "") ||
        (typeof value === "object" && value?.value && value.value.trim() !== "") ||
        "City is Required!"
    },
    defaultValue: null
  },
  state: {
    label: "State/Province",
    defaultValue: null,
    perKey: "State",
    rules: { required: "State/Province is Required!" }
  },
  internalProjectId: {
    label: "Project ID No",
    perKey: "InternalProjectId",
    rules: { required: "Project ID No is Required!" }
  },
  zipCode: {
    label: "Zip",
    perKey: "ZipCode",
    rules: { required: "Zip Code is Required!" }
  },
  primaryCounties: {
    label: "Primary County",
    perKey: "PrimaryCounties",
    rules: { required: "Primary County is Required!" },
    defaultValue: null
  },
  country: {
    label: "Country",
    perKey: "Country"
  },
  nercRegion: {
    label: "NERC Region",
    perKey: "NERCRegion"
  },
  isoTerritory: {
    label: "ISO Territory",
    perKey: "ISOTerritory"
  },
  lat: {
    label: "Latitude Coordinate (GPS Location)",
    perKey: "Lat"
  },
  long: {
    label: "Longitude Coordinate (GPS Location)",
    perKey: "Long"
  },
  wageDeterminationNumber: {
    label: "Wage Determination Number",
    perKey: "WageDeterminationNumber",
    rules: {
      maxLength: {
        value: 25,
        message: "Maximum 25 characters allowed"
      },
      pattern: {
        value: /^[a-zA-Z0-9/ ]+$/,
        message: "Only alphanumeric characters, spaces, and '/' are allowed"
      }
    }
  },
  wageDeterminationDocumentFile: {
    label: "Wage Determination File",
    type: "file",
    perKey: "WageDeterminationDocumentFile",
    defaultValue: null
  },
  projectOwner: {
    label: "Who is the Project Owner (Tax Payer/Incentive(s))?",
    defaultValue: null,
    perKey: "ProjectOwner"
  },
  projectDeveloper: {
    label: "Who is the  Project Developer (if different than Owner)?",
    defaultValue: null,
    perKey: "ProjectDeveloper"
  },
  projectEPC: {
    label: "Who is the  Project EPC (if different than Owner & Developer)?",
    defaultValue: null,
    perKey: "ProjectEPS"
  },
  workId: {
    label: "Work Category",
    perKey: "WorkType",
    defaultValue: null
  },
  mobileAppTimeKeepingManagement_QC: {
    label: "QR Code"
  },
  mobileAppTimeKeepingManagement_MO: {
    label: "Multiple Occupation",
    perKey: "ZipCode"
  },
  mobileAppTimeKeepingManagement_FC: {
    label: "Facial Recognisation",
    perKey: "ZipCode"
  },
  projectKickoff: {
    label: "Project Kickoff (Season)?",
    perKey: "KickoffSeason"
  },
  documentType: {
    label: "Document Type",
    perKey: "DocumentType"
  },
  actualConstructionStartDate: {
    label: "Actual Construction Start Date",
    defaultValue: null,
    perKey: "ActualConstructionStartDate",
    rules: { required: "Actual Construction Start Date is Required!" }
  },
  projectType: {
    label: "Project Type",
    perKey: "ProjectType"
  },
  projectStatus: {
    label: "Project Status",
    perKey: "ProjectStatus"
  },
  eiaId: {
    label: "EIA ID",
    defaultValue: null,
    perKey: "EIAId"
  },
  dockets: {
    label: "Dockets",
    perKey: "Dockets"
  },
  batteryType: {
    label: "Battery Type",
    perKey: "BatteryType"
  },
  communitySolar: {
    label: "Community Solar?",
    defaultValue: null,
    perKey: "CommunitySolar"
  },
  coLocatedProject: {
    label: "Co Located Project?",
    perKey: "CoLocatedProject"
  },
  projectCapacityMW: {
    label: "Project Capacity MW",
    type: "number",
    defaultValue: 0,
    perKey: "ProjectCapacityMW"
  },
  projectClassification: {
    label: "Project Classification",
    perKey: "ProjectClassification"
  },
  powerPurchaser: {
    label: "Power Purchaser",
    perKey: "PowerPurchaser"
  },
  powerPurchaseAgreementCapacityMW: {
    label: "Power Purchase Agreement Capacity MW",
    perKey: "PowerPurchaseAgreementCapacityMW"
  },
  powerPurchaseAgreementYears: {
    label: "Power Purchase Agreement Years",
    perKey: "PowerPurchaseAgreementYears"
  },
  supplier: {
    label: "Supplier",
    perKey: "Supplier"
  },

  unitType: {
    label: "Unit Type",
    perKey: "UnitType"
  },
  unitSupplied: {
    label: "Unit Supplied",
    perKey: "UnitSupplied"
  },
  firstPowerDate: {
    label: "First Power Date",
    defaultValue: null,
    perKey: "FirstPowerDate"
  },
  firstPowerYear: {
    label: "First Power Year",
    perKey: "FirstPowerYear"
  },
  projectLastUpdatedDate: {
    label: "Project Last Updated Date",
    perKey: "ProjectLastUpdatedDate",
    defaultValue: null
  },
  projectAcresSize: {
    label: "How many acres is the project?",
    perKey: "ProjectAcres"
  },
  constructionSiteCounties: {
    label: "How many counties fall within the construction site?",
    perKey: "CountiesInConstructionSite"
  },
  totalConstructionDays: {
    label: "Total Construction Days (Est.)?",
    perKey: "TotalConstructionDays",
    type: "number",
    defaultValue: 0
  },
  targetConstructionStartDate: {
    label: "Target Construction Start Date",
    perKey: "TargetConstructionStartDate",
    defaultValue: null,
    rules: {
      validate: (value, formValues) => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter valid date";
        if (formValues.targetCODDate && formValues.targetCODDate < value) {
          return "Target Construction Start Date should be less than Target COD Date";
        }
      }
    }
  },
  projectCapacityAC: {
    label: "Project Capacity AC (MW)?",
    perKey: "ACCapacity",
    type: "number",
    defaultValue: 0
  },
  projectCapacityDC: {
    label: "Project Capacity DC (MW)?",
    perKey: "DCCapacity",
    type: "number",
    defaultValue: 0
  },
  targetCODDate: {
    label: "Target COD Date?",
    perKey: "TargetCODDate",
    defaultValue: null,
    rules: {
      validate: (value, formValues) => {
        if (!value) return true;
        if (value.isValid && !value.isValid()) return "Enter valid date";
        if (formValues.targetConstructionStartDate && formValues.targetConstructionStartDate > value) {
          return "Target COD Date should be greater than Target Construction Start Date";
        }
      }
    }
  },
  moduleSelected: {
    label: "Module Selected",
    perKey: "ModuleSelected"
  },
  moduleType: {
    label: "Module Type",
    perKey: "ModuleType"
  },
  modulQuantity: {
    label: "Module Quantity",
    perKey: "ModulQuantity",
    type: "number",
    defaultValue: 0
  },
  stringSizes: {
    label: "String Sizes",
    perKey: "StringSizes"
  },
  structureSelected: {
    label: "Structure Selected",
    perKey: "StructureSelected"
  },
  structureManufacturer: {
    label: "Structure Manufacturer",
    perKey: "StructureManufacturer"
  },
  rowCount: {
    label: "Table or Row Count",
    perKey: "TableOrRowCount"
  },
  pileAmount: {
    label: "Pile Amount",
    perKey: "PileAmount"
  },
  pileType: {
    label: "Pile Type",
    perKey: "PileType"
  },
  pileEmbedmentDepth: {
    label: "Pile Embedment Depth",
    perKey: "PileEmbedmentDepth",
    type: "number",
    defaultValue: null
  },
  blowMinCountRange: {
    label: "Blow Min Count Range",
    perKey: "BlowMinCountRange",
    type: "number",
    defaultValue: 0
  },
  blowMaxCountRange: {
    label: "Blow Max Count Range",
    perKey: "BlowMaxCountRange",
    type: "number",
    defaultValue: 0
  },
  inverterSelected: {
    label: "Inverter Selected",
    perKey: "InverterSelected"
  },
  inverterType: {
    label: "Inverter Type",
    perKey: "InverterType"
  },
  inverterQuantity: {
    label: "Inverter Quantity",
    perKey: "InverterQuantity",
    type: "number",
    defaultValue: 0
  },
  DCRatio: {
    label: "DC Ratio",
    perKey: "DCRatio",
    type: "number",
    defaultValue: 0
  },
  ACRatio: {
    label: "AC Ratio",
    perKey: "ACRatio",
    type: "number",
    defaultValue: 0
  },

  materialProcurement: {
    label: "Material Procurement",
    perKey: "MaterialProcurement"
  },

  interconnectingUtility: {
    label: "Interconnecting Utility",
    perKey: "InterconnectingUtility"
  },
  interconnectionApproval: {
    label: "Interconnection Approval",
    perKey: "InterconnectionApproval"
  },
  interconnectionTiming: {
    label: "Interconnection Timing",
    perKey: "InterconnectionTiming"
  },
  interconnectionVoltage: {
    label: "Interconnection Voltage",
    perKey: "InterconnectionVoltage",
    type: "number",
    defaultValue: 0
  },
  interconnectPoint: {
    label: "Interconnect Point / Substation",
    perKey: "InterconnectPoint"
  },
  interconnectDistance: {
    label: "Interconnect Distance",
    perKey: "InterconnectDistance"
  },
  ROWRequired: {
    label: "ROW Required?",
    perKey: "IsRowRequired",
    defaultValue: null
  },
  interconnectQueueStatus: {
    label: "Status of Interconnect Queue",
    perKey: "InterconnectQueueStatus"
  },
  substationCongestion: {
    label: "Substation Congestion/ Capacity",
    perKey: "SubstationCongestion"
  },
  interconnectionUtilityProcess: {
    label: "Utility Interconnection Process",
    perKey: "InterconnectionUtilityProcess"
  },
  interconnectNetworkUpgrades: {
    label: "Existing Interconnect Network Upgrades",
    perKey: "InterconnectNetworkUpgrades"
  },
  dataConnectionAvailability: {
    label: "Data Connection Hardline Availability",
    perKey: "DataConnectionAvailability"
  },

  permittingAuthority: {
    label: "Permitting Authority",
    perKey: "PermittingAuthority"
  },
  heightLimit: {
    label: "Height Limit",
    type: "number",
    defaultValue: 0,
    perKey: "HeightLimit"
  },
  projectDocumentType: {
    label: "Project Document Type",
    perKey: "ProjectDocumentType",
    defaultValue: null
  },
  projectDocumentFile: {
    label: "Document",
    type: "file",
    perKey: "ProjectDocumentPath"
  }
};

export const projectData = [
  {
    id: 1,
    stateName: "Wichita",
    countyName: "Kansas",
    cityName: "Wichita"
  },
  {
    id: 2,
    stateName: "Wichita",
    countyName: "Kansas",
    cityName: "Wichita"
  },
  {
    id: 3,
    stateName: "Wichita",
    countyName: "Kansas",
    cityName: "Wichita"
  },
  {
    id: 4,
    stateName: "Wichita",
    countyName: "Kansas",
    cityName: "Wichita"
  },
  {
    id: 5,
    stateName: "Wichita",
    countyName: "Kansas",
    cityName: "Wichita"
  }
];

export const ProjectSchedulingConfig = {
  deliverySchedule: {
    label: "What is your Equipment Delivery Schedule?",
    perKey: "EquipmentDeliverySchedule",
    rules: { required: "Schedule is required!" }
  },
  attachmentFile: {
    label: "File",
    perKey: "EquipmentDeliveryScheduleAttachmentPath",
    type: "file",
    defaultValue: null
  }
};

export const ProjectPartnerConfig = {
  client: {
    label: "Partner",
    perKey: "Partner"
  },
  clientContact: {
    label: "Partner Contact ",
    perKey: "PartnerContact"
  },
  contractType: {
    label: "Partner Type ",
    perKey: "PartnerType"
  },
  estimatedStartDate: {
    label: "Estimated Start Date",
    defaultValue: null
  },
  documentSubmissionStartDate: {
    label: "Document Submission Start Date",
    defaultValue: null
  }
};

export const profileFormNames = [
  "Project Name and Address",
  "Project Ownership(Partners)",
  "Project Partners",
  "Project Details",
  "Project Details(Required Info)",
  "Project Site : Module Info",
  "Project Site : Structure Info",
  "Project Site : Inverter Detail",
  "Project Site : Material & Equipment Scheduling Info",
  "Project Site : Interconnection Info",
  "Project Site : Permitting & Entitlement Detail"
];

export const projectJobFormConfing = {
  isExternalJobTitle: {
    label: "External Job Title",
    perKey: "isExternalJobTitle"
  },
  typeOfJob: {
    label: "Select the Labor Classification(s) that aligns to the Job Description/Tasks",
    perKey: "typeOfJob",
    rules: { required: "Labor Classification Position is required!" },
    withInfoIcon: true,
    infoMessage: "This field is the Labor Classification that is displayed on the CPR."
  },
  jobTitleId: {
    label: "Job Title",
    perKey: "JobTitle",
    rules: { required: "Labor Classification Title is required!" },
    withInfoIcon: true,
    infoMessage: "The name in this box must match exactly to Time and Payroll Import Template Labor Classification for successful upload."
  },
  externalJobTitle: {
    label: "External Labor Classification Title ",
    perKey: "ExternalJobTitle",
    rules: { required: "External Labor Classification Title is required!" }
  },
  numberOfPositions: {
    label: "Number Of Position ",
    perKey: "NumberofPositions",
    type: "number",
    rules: {
      validate: validatePositiveInteger({ min: 1, max: 999 })
    },
    fieldProps: {
      inputProps: { min: 1, max: 999, step: 1 },
      onKeyDown: e => {
        // Block characters that are valid in a number input but not positive integers.
        if (["e", "E", "+", "-", ".", ","].includes(e.key)) {
          e.preventDefault();
        }
      }
    }
  },
  jobInternalId: {
    label: "Internal Labor Classification Id",
    perKey: "JobInternalId"
  },
  jobDescription: {
    label: "Job Description/Tasks",
    perKey: "JobDescription",
    fieldProps: { multiline: true, rows: 4 },
    rules: { required: "Labor Classification Description is required!" },
    withInfoIcon: true,
    infoMessage: "Short description of type of work or tasks performed."
  },
  payTypePosition: {
    label: "Pay Type ",
    perKey: "PayType",
    withInfoIcon: true,
    rules: { required: "Pay Type is required!" },
    infoMessage:
      "Consider creating separate job entries for roles that involve both hourly and salary-based pay structures. This ensures accurate tracking and simplifies payroll management."
  },
  perDiem: {
    label: "Per Diem",
    perKey: "PerDiem"
  },
  laborClassificationType: {
    label: "Labor Classification Type",
    perKey: "laborClassificationType",
    defaultValue: null,
    rules: { required: "Labor Classification Type is required!" }
  },
  isUnion: {
    label: "Is the employee classified under Union Labor?",
    perKey: "isUnion"
  },
  marketRate: {
    label: "Market Rate",
    perKey: "MarketRate"
  },
  pwAiConfidenceMatchScore: {
    label: "PW AI % Confidence Score",
    perKey: "TitleMatch"
  },
  salaryAmount: {
    label: "Salary Amount",
    perKey: "SalaryAmount"
  },
  samFileName: {
    label: "PW File Name",
    perKey: "samFileName"
  },
  samFilePath: {
    label: "PW File Name Path",
    perKey: "samFilePath"
  },
  generalDecisionNumber: {
    label: "PW General Decision Number",
    perKey: "generalDecisionNumber"
  },
  prevailingStraightTimeWage: {
    label: "Prevailing Wage Rate",
    perKey: "prevailingStraightTimeWage",
    rules: {
      required: "Prevailing Wage Rate is required!",
      validate: validateNegativeNumber("Prevailing Wage Rate")
    }
  },
  prevailingStraightTimeFringe: {
    label: "Prevailing Fringe",
    perKey: "prevailingStraightTimeFringe",
    rules: {
      required: "Prevailing Fringe is required!",
      validate: validateNegativeNumber("Prevailing Fringe")
    }
  },
  prevailingStraightTimeTotalHourlyComp: {
    label: "Prevailing Total Hourly Comp",
    perKey: "prevailingStraightTimeTotalHourlyComp"
  },
  prevailingOverTimeWage: {
    label: "Overtime Wage Rate",
    perKey: "prevailingOverTimeWage",
    rules: {
      required: "Overtime Wage Rate is required!",
      validate: validateNegativeNumber("Overtime Wage Rate")
    }
  },
  prevailingOverTimeFringe: {
    label: "Overtime Fringe",
    perKey: "prevailingOverTimeFringe",
    rules: {
      required: "Overtime Fringe is required!",
      validate: validateNegativeNumber("Overtime Fringe")
    }
  },
  prevailingOverTimeTotalHourlyComp: {
    label: "Overtime Total Hourly Compensation",
    perKey: "prevailingOverTimeTotalHourlyComp"
  },
  prevailingDoubleTimeWage: {
    label: "Double Time Wage Rate",
    perKey: "prevailingDoubleTimeWage",
    rules: {
      required: "Double Time Wage Rate is required!",
      validate: validateNegativeNumber("Double Time Wage Rate")
    }
  },
  prevailingDoubleTimeFringe: {
    label: "Double Time Fringe",
    perKey: "prevailingDoubleTimeFringe",
    rules: {
      required: "Double Time Fringe is required!",
      validate: validateNegativeNumber("Double Time Fringe")
    }
  },
  prevailingDoubleTimeTotalHourlyComp: {
    label: "Double Time Total Hourly Compensation",
    perKey: "prevailingDoubleTimeTotalHourlyComp"
  },
  unionStraightTimeWage: {
    label: "Union Wage Rate",
    perKey: "unionStraightTimeWage",
    rules: {
      validate: validateNegativeNumber("Union Wage Rate"),
      required: "Union Wage Rate is required!"
    }
  },
  unionStraightTimeFringe: {
    label: "Union Fringe",
    perKey: "unionStraightTimeFringe",
    rules: {
      validate: validateNegativeNumber("Union Fringe"),
      required: "Union Fringe is required!"
    }
  },
  unionStraightTimeFringeHealthAndWelfare: {
    perKey: "unionStraightTimeFringeHealthAndWelfare"
  },
  unionStraightTimeFringePension: {
    perKey: "unionStraightTimeFringePension"
  },
  unionStraightTimeFringeAnnuity: {
    perKey: "unionStraightTimeFringeAnnuity"
  },
  unionStraightTimeFringeApprenticeTraining: {
    perKey: "unionStraightTimeFringeApprenticeTraining"
  },
  unionStraightTimeFringeVacation: {
    perKey: "unionStraightTimeFringeVacation"
  },
  unionStraightTimeFringeOther: {
    perKey: "unionStraightTimeFringeOther"
  },
  unionEffectiveDateEnd: {
    label: "Union Wage Rate Expiration Date",
    perKey: "unionEffectiveDateEnd",
    defaultValue: null,
    rules: {
      validate: validateWageRateExpirationDate
    }
  },
  unionStraightTimeTotalHourlyComp: {
    label: "Total Union Hourly Comp",
    perKey: "unionStraightTimeTotalHourlyComp"
  },
  unionOverTimeWage: {
    label: "Overtime Wage Rate",
    perKey: "unionOverTimeWage",
    rules: {
      validate: validateNegativeNumber("Overtime Wage Rate")
    }
  },
  unionOverTimeFringe: {
    label: "Overtime Fringe",
    perKey: "unionOverTimeFringe",
    rules: {
      validate: validateNegativeNumber("Overtime Fringe")
    }
  },
  unionOverTimeTotalHourlyComp: {
    label: "Overtime Total Hourly Comp",
    perKey: "unionOverTimeTotalHourlyComp"
  },
  hasOTFringeOverride: {
    label: "Do the overtime fringe fees differ from the regular fringe fees?",
    perKey: "hasOTFringeOverride",
    defaultValue: false
  },
  unionOverTimeFringeHealthAndWelfare: {
    perKey: "unionOverTimeFringeHealthAndWelfare",
    defaultValue: null
  },
  unionOverTimeFringePension: {
    perKey: "unionOverTimeFringePension",
    defaultValue: null
  },
  unionOverTimeFringeAnnuity: {
    perKey: "unionOverTimeFringeAnnuity",
    defaultValue: null
  },
  unionOverTimeFringeApprenticeTraining: {
    perKey: "unionOverTimeFringeApprenticeTraining",
    defaultValue: null
  },
  unionOverTimeFringeVacation: {
    perKey: "unionOverTimeFringeVacation",
    defaultValue: null
  },
  unionOverTimeFringeOther: {
    perKey: "unionOverTimeFringeOther",
    defaultValue: null
  },
  unionDoubleTimeWage: {
    label: "Double-time Wage Rate",
    perKey: "unionDoubleTimeWage",
    rules: {
      validate: validateNegativeNumber("Double-time Wage Rate")
    }
  },
  unionDoubleTimeFringe: {
    label: "Double-time Fringe",
    perKey: "unionDoubleTimeFringe",
    rules: {
      validate: validateNegativeNumber("Double-time Fringe")
    }
  },
  unionDoubleTimeTotalHourlyComp: {
    label: "Double-time Total Comp",
    perKey: "unionDoubleTimeTotalHourlyComp"
  },
  hasDTFringeOverride: {
    label: "Do the double-time fringe fees differ from the regular fringe fees?",
    perKey: "hasDTFringeOverride",
    defaultValue: false
  },
  unionDoubleTimeFringeHealthAndWelfare: {
    perKey: "unionDoubleTimeFringeHealthAndWelfare",
    defaultValue: null
  },
  unionDoubleTimeFringePension: {
    perKey: "unionDoubleTimeFringePension",
    defaultValue: null
  },
  unionDoubleTimeFringeAnnuity: {
    perKey: "unionDoubleTimeFringeAnnuity",
    defaultValue: null
  },
  unionDoubleTimeFringeApprenticeTraining: {
    perKey: "unionDoubleTimeFringeApprenticeTraining",
    defaultValue: null
  },
  unionDoubleTimeFringeVacation: {
    perKey: "unionDoubleTimeFringeVacation",
    defaultValue: null
  },
  unionDoubleTimeFringeOther: {
    perKey: "unionDoubleTimeFringeOther",
    defaultValue: null
  },
  footnoteSickDays: {
    label: "PW Sick Leave",
    perKey: "footnoteSickDays",
    fieldProps: { multiline: true, rows: 5, disabled: true }
  },
  footnoteVacationDays: {
    label: "PW Vacation",
    perKey: "footnoteVacationDays",
    fieldProps: { multiline: true, rows: 5, disabled: true }
  },
  footnoteHolidays: {
    label: "PW Holiday",
    perKey: "footnoteHolidays",
    fieldProps: { multiline: true, rows: 5, disabled: true }
  },
  footnoteOthers: {
    label: "PW Other Footnotes",
    perKey: "footnoteOthers",
    fieldProps: { multiline: true, rows: 5, disabled: true }
  },
  isApprenticeable: {
    label: "Apprenticeship Eligible",
    perKey: "IsApprenticeable"
  },
  isCustomApprenticeOnboardingRequired: {
    label: "Custom Apprentice Onboarding Required",
    perKey: "isCustomApprenticeOnboardingRequired"
  },
  assignRAPInfoGuid: {
    label: "Rap",
    perKey: "Rap"
  },
  assignRAPWageScaleGuid: {
    label: "AWS",
    perKey: "AWS"
  },
  occupationTitle: {
    label: "Occupation Title",
    perKey: "OccupationTitle"
  },
  onetCode: {
    label: "ONET Code",
    perKey: "OnetCode"
  },
  groupClassification: {
    label: "Group Classification",
    perKey: "GroupClassification"
  },
  equipmentUsed: {
    label: "Equipment Used",
    perKey: "EquipmentUsed",
    fieldProps: { multiline: true, rows: 3, disabled: true }
  }
};

export const projectEmployeeFormConfing = {
  isApprentice: {
    label: "Apprentice",
    perKey: "Apprentice"
  },
  isMentor: {
    label: "Mentor"
    // perKey: "Mentor"
  },
  projectJobTitleId: {
    label: "Labor Classification Title ",
    perKey: "JobTitle",
    rules: { required: "Labor Classification Title is required!" }
  },
  employeeId: {
    label: "Employee ",
    perKey: "Employee",
    rules: { required: "Employee is required!" }
  },
  mentorId: {
    label: "Mentor",
    perKey: "Mentor"
  },
  startDate: {
    label: "Start Date ",
    rules: { required: "Start Date is required!" },
    defaultValue: null,
    perKey: "StartDate"
  },
  endDate: {
    label: "End Date",
    defaultValue: null,
    perKey: "EndDate"
  },
  employmentTermTypeId: {
    label: "Employee Term Type",
    perKey: "EmployeeTermType"
  },
  perDiem: {
    label: "Per Diem",
    perKey: "PerDiem"
  },
  rate: {
    label: "Hourly Wage Rate",
    perKey: "HourlyRate"
  },
  fringe: {
    label: "Fringe",
    perKey: "Fringe"
  },
  actualHourlyRate: {
    label: "Actual Hourly Rate",
    perKey: "ActualHourlyRate"
  },
  isActive: {
    label: "Is Active",
    type: "checkbox",
    defaultValue: false
  },
  typicalshiftdays: {
    label: "Typical Shift Start & End Day",
    defaultValue: [],
    perKey: "TypicalShiftDay"
  },
  shiftStartTime: {
    label: "Typical Shift Start Time",
    defaultValue: null,
    perKey: "ShiftStartTime"
  },
  shiftEndTime: {
    label: "Typical Shift End Time",
    defaultValue: null,
    perKey: "ShiftEndTime"
  }
};

export const constructionType = "Heavy";
